import React from "react";
import { motion } from "framer-motion";

function Features() {
  const features = [
    {
      title: "Smart Automation & Control Systems",
      description:
        "Implement intelligent automation solutions using PLCs, SCADA, and IoT technologies to improve operational efficiency, reduce downtime, and enhance production quality.",
      color: "#1E40AF",
      animation: { x: -100, y: 0 },
    },
    {
      title: "Robotics Integration & Programming",
      description:
        "Deploy and program industrial robots for tasks such as assembly, welding, material handling, and packaging, ensuring precision, speed, and safety in manufacturing processes.",
      color: "#2563EB",
      animation: { x: 100, y: 0 },
    },
    {
      title: "Predictive Maintenance & Monitoring",
      description:
        "Use real-time data analytics and AI-powered monitoring systems to predict equipment failures before they occur, minimizing unexpected breakdowns and maintenance costs.",
      color: "#9333EA",
      animation: { x: 0, y: 100 },
    },
    {
      title: "Process Optimization & Efficiency",
      description:
        "Analyze and optimize production workflows using automation to reduce waste, improve throughput, and enhance overall operational productivity.",
      color: "#059669",
      animation: { x: -100, y: 0 },
    },
    {
      title: "Seamless Integration with Existing Systems",
      description:
        "Integrate new automation technologies with existing production lines and IT systems to ensure smooth operations without major disruptions.",
      color: "#DC2626",
      animation: { x: 100, y: 0 },
    },
    {
      title: "Energy-Efficient & Sustainable Automation",
      description:
        "Design and implement automation solutions that reduce energy consumption, minimize environmental impact, and comply with green manufacturing standards.",
      color: "#F59E0B",
      animation: { x: 0, y: -100 },
    },
  ];

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "linear-gradient(to right, #e0f2fe, #f8fafc)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "32px",
      marginBottom: "40px",
      fontWeight: "bold",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)", // 3 columns
      gap: "25px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      padding: "25px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "180px",
      cursor: "pointer",
    },
    title: {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#374151",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Key Features of Our Engineering Design Solutions</h2>
      <div style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ ...feature.animation, opacity: 0 }}
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
              e.currentTarget.style.transform = "translateY(-5px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
